import { http } from '../../utils';
import { FIREBASE_AUTH_BASE_URL } from '../../constants';

export function createFirebaseToken(accessToken) {
  return http.post(`${FIREBASE_AUTH_BASE_URL}/auth/token`, {
    access_token: accessToken,
  });
}
